import React, { useState, FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'

import { InsufficientPermissions } from '../common'
import { getAuthUser } from '../../helpers'
import { createRecord, CreateRecordParams } from '../../api'
import { RecordForm } from './form'
import defineAbilityFor from './defineAbility'
import { RecordStatus } from '../../models'

export const AddRecordForm = () => {
    const navigate = useNavigate()
    const ability = defineAbilityFor(getAuthUser())
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleSubmit = async (
        e: FormEvent<HTMLFormElement>,
        inputs: CreateRecordParams
    ) => {
        e.preventDefault()
        setIsSubmitting(true)
        
        const params = { ...inputs } as any

        if (!RecordStatus.PAID_STATUSES.includes(params.status)) {
            delete params.payment_method_id
        }

        try {
            const response = await createRecord(inputs)
            navigate(`/records/${response.data.id}`)
        } catch (error) {
            // Error is handled by axios interceptor
        } finally {
            setIsSubmitting(false)
        }
    }

    if (!ability.can('Create', 'Record')) {
        return <InsufficientPermissions />
    }

    return (
        <div className='container card col-xs-12 col-xl-6'>
            <div className='card-body col-xs-12 row d-flex flex-row justify-content-between mb-5'>
                <div className='row flex-row mb-5'>
                    <h3 className='ps-0 d-inline-flex card-title w-50'>
                        Create New Record
                    </h3>
                </div>
                <RecordForm handleSubmit={handleSubmit} isSubmitting={isSubmitting} />
            </div>
        </div>
    )
}
